
<script>
    import { selectedItem } from '../../../store/store.js';

    function displayUthyrningPermission(item) {
		if (item === true) {
			return "Tillåtelse krävs för uthyrning."
		}
		else if (item === false) {
			return "Tillåtelse krävs ej för uthyrning."
		}
		else {
			return "Uppgifter saknas"
		}
	}
</script>

<div class="key-value-table box">
    <h5>Rättigheter och skylldigheter</h5>

    <h6 style="font-weight: 500;">Tillträde till lägenheten</h6>
    <h6>{$selectedItem?.rights_and_obligations?.access_rights ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Andrahandsuthyrning</h6>
    <h6>{$selectedItem?.rights_and_obligations?.subletting_rules?.time_limits ?? "Uppgifter saknas"}</h6>
    <h6>{$selectedItem?.rights_and_obligations?.subletting_rules?.fee_structure ?? "Uppgifter saknas"}</h6>
    <h6>{$selectedItem?.rights_and_obligations?.subletting_rules?.special_conditions ?? "Uppgifter saknas"}</h6>
    <h6>{displayUthyrningPermission($selectedItem?.rights_and_obligations?.subletting_rules?.permission_required)}</h6>

    <h6 style="font-weight: 500;">Försäkringskrav</h6>
    <h6>{$selectedItem?.rights_and_obligations?.insurance_requirements ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Ändringar i lägenheten</h6>
    <h6>{$selectedItem?.rights_and_obligations?.property_modifications?.restricted_actions ?? "Uppgifter saknas"}</h6>
    <h6>{$selectedItem?.rights_and_obligations?.property_modifications?.permission_requirements ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Störningar och ordning</h6>
    <h6>{$selectedItem?.rights_and_obligations?.noise_and_conduct_rules ?? "Uppgifter saknas"}</h6>

    <h6 style="font-weight: 500;">Underhållsskylldighet</h6>
    <h6>{$selectedItem?.rights_and_obligations?.maintenance_responsibilities?.member_responsibilities ?? "Uppgifter saknas"}</h6>
    <h6>{$selectedItem?.rights_and_obligations?.maintenance_responsibilities?.association_responsibilities ?? "Uppgifter saknas"}</h6>
</div>